import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=18ca20c2&"
import script from "./MainLayout.vue?vue&type=script&lang=js&"
export * from "./MainLayout.vue?vue&type=script&lang=js&"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=18ca20c2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2044461438/src/tacotrade-platform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ca20c2')) {
      api.createRecord('18ca20c2', component.options)
    } else {
      api.reload('18ca20c2', component.options)
    }
    module.hot.accept("./MainLayout.vue?vue&type=template&id=18ca20c2&", function () {
      api.rerender('18ca20c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/MainLayout.vue"
export default component.exports